<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="deliveryNo">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="supplier">
                <wbo-supplier-multi-select-search-control></wbo-supplier-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'dateFrom'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'dateTo'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'orderNo'">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'status'">
                <wbo-single-select-search-control>
                    <wbo-select-options>
                        <wbo-select-option value="'Pending'"
                                           label="wbo.receive-order.option.status.pending"></wbo-select-option>
                        <wbo-select-option value="'Complete'"
                                           label="wbo.receive-order.option.status.complete"></wbo-select-option>
                        <wbo-select-option value="'Invoiced'"
                                           label="wbo.receive-order.option.status.invoiced"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'inventory'">
                <wbo-inventory-multi-select-search-control></wbo-inventory-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-column field="deliveryNo"></wbo-column>
        <wbo-date-column field="receiveDate"></wbo-date-column>
        <wbo-column field="orderNo"></wbo-column>
        <wbo-column field="supplier"></wbo-column>
        <wbo-column field="status"></wbo-column>
        <wbo-column field="employee"></wbo-column>
        <wbo-actions-search-column>
            <wbo-report-search-action [idColumn]="'receivingId'"></wbo-report-search-action>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
